// extracted by mini-css-extract-plugin
var _1 = "webpack-concepts-Extraction-Preview-BuildPreview-module__item";
export { _1 as "item" }
